import type React from "react";
import { Check } from "lucide-react";
import { Button } from "@planta-v2/pds-ui/button";
import { i18n } from "@frontend/i18n";

export function RequestedButton(): React.JSX.Element {
  return (
    <div className="flex flex-col items-center gap-2">
      <Button
        variant="secondary"
        disabled
        data-testid="requested-button"
        className="w-full gap-2"
        size="lg"
      >
        <Check className="h-4 w-4" />
        {i18n.t("user.directory.profile.cta.requested")}
      </Button>
      <p className="text-pds-2xs text-center text-muted-foreground">
        {i18n.t("user.directory.profile.cta.requestedHelp")}
      </p>
    </div>
  );
}
